/* eslint-disable import/prefer-default-export */
/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from './slice';
//
const selectDomain = (state) => state[SLICE.SEARCH] || initialState;
/**
 * Getting search state for pace segment component
 */
export const selectLoader = createSelector([selectDomain], (state) => state?.loading);
/**
 * Getting search state for pace segment component
 */
export const selectSearchData = createSelector([selectDomain], (state) => state?.searchData);

/**
 * Getting search widget booking date state to search widget component
 */
export const selectSearchBookingDate = createSelector(
  [selectDomain],
  (state) => state.searchBookingDate
);
/**
 * Getting chart breakdown state to search widget component
 */
export const selectBreakdown = createSelector([selectDomain], (state) => state.chartBreakdown);

/**
 * Getting date comparison state to search widget component
 */
export const selectDateComparison = createSelector([selectDomain], (state) => state.dateComparison);

/**
 * Getting search report filter list state to search widget component
 */
export const selectSearchFilterList = createSelector(
  [selectDomain],
  (state) => state.searchFilterList
);
/**
 * Getting alignment state to search widget component
 */
export const selectAlignment = createSelector([selectDomain], (state) => state.alignment);
/**
 *  Getting search widget alignment toggle state to search widget component
 */
export const selectSearchAlignmentToggle = createSelector(
  [selectDomain],
  (state) => state.searchAlignmentToggle
);
/**
 * Getting search otb state for search widget component
 */
export const selectSearchOtb = createSelector([selectDomain], (state) => state?.searchOtb);

/**
 *Getting is search custom date state for search widget component
 */
export const selectSearchCustomDate = createSelector(
  [selectDomain],
  (state) => state?.searchCustomDate
);

/**
 *Getting is search start date state for search widget component for custom date comparison
 */
export const selectSearchStartDate = createSelector(
  [selectDomain],
  (state) => state?.searchStartDate
);

/**
 *Getting is search end date state for search widget component for custom date comparison
 */
export const selectSearchEndDate = createSelector([selectDomain], (state) => state?.searchEndDate);

/**
 *Getting is search date selected state for search widget component for custom date comparison
 */
export const selectSearchDateSelected = createSelector(
  [selectDomain],
  (state) => state?.searchDateSelected
);
/**
 * Getting search widget visual toggle state to search widget component
 */
export const selectSearchVisualToggle = createSelector(
  [selectDomain],
  (state) => state.searchVisualToggle
);
/**
 *  Getting generated search tab url
 */
export const selectSearchUrl = createSelector([selectDomain], (state) => state.searchUrl);
/**
 * Getting symmetric comparison toggle state for search widget component
 */
export const selectSymmetricComparisonToggle = createSelector(
  [selectDomain],
  (state) => state?.symmetricComparisonToggle
);
/**
 *Getting is detailed in search tab state for search widget component
 */
export const selectIsDetailed = createSelector([selectDomain], (state) => state?.isDetailed);
/**
 * Getting pace visual filter list state to search widget component
 */
export const selectPaceVisualFilterList = createSelector(
  [selectDomain],
  (state) => state.paceVisualFilterList
);
/**
 *  Getting pace visual display state to the component
 */
export const selectPaceVisualIsDisplay = createSelector(
  [selectDomain],
  (state) => state.paceVisualIsDisplay
);
/**
 *  Getting symmetric comparison visual display state to the component
 */
export const selectSymmetricComparisonIsDisplay = createSelector(
  [selectDomain],
  (state) => state.symmetricComparisonIsDisplay
);
/**
 *  Getting revenue visual set display state to the component
 */
export const selectRevenueSetIsDisplay = createSelector(
  [selectDomain],
  (state) => state.revenueSetIsDisplay
);
/**
 *  Getting cancel count visual set display state to the component
 */
export const selectCxlSetIsDisplay = createSelector(
  [selectDomain],
  (state) => state.cxlSetIsDisplay
);
/**
 *  Getting selected enable secondary hotel state to the component
 */
export const selectEnableSecondaryHotelGroups = createSelector(
  [selectDomain],
  (state) => state.enableSecondaryHotelGroups
);
/**
 *  Getting hotel view focus on state to dashboard component
 */
export const selectHotelFocusOn = createSelector([selectDomain], (state) => state.hotelFocusOn);
/**
 *Getting normalized view state for the component
 */
export const selectNormalizedView = createSelector(
  [selectDomain],
  (state) => state?.normalizedView
);
/**
 *Getting search visual state for the component
 */
export const selectSearchVisual = createSelector([selectDomain], (state) => state?.searchVisuals);
/**
 *Getting search hotel comparison visual state for the component
 */
export const selectSearchHotelVisual = createSelector(
  [selectDomain],
  (state) => state?.searchHotelVisuals
);
/**
 *Getting is search hotel comparison state for the component
 */
export const selectSearchHotelComparison = createSelector(
  [selectDomain],
  (state) => state?.isSearchHotelComparison
);
/**
 *  Getting is original focus on state to the component
 */
export const selectOriginalHotelFocusOn = createSelector(
  [selectDomain],
  (state) => state.originalFocusOn
);
/**
 *  Getting is Search Leap Comparison state to the component
 */
export const selectIsSearchLeapComparison = createSelector(
  [selectDomain],
  (state) => state.isSearchLeapComparison
);
/**
 *  Getting is percentage forecast state to pace  time component
 */
export const selectPercentage = createSelector([selectDomain], (state) => state.percentage);
/**
 *  Getting trend segment view focus on state to trend  component
 */
export const selectFocusOn = createSelector([selectDomain], (state) => state.focusOn);
/**
 *  Getting is percentage change state to the component
 */
export const selectIsPercentageChange = createSelector(
  [selectDomain],
  (state) => state.isTrendPercentageChange
);
/**
 *  Getting is aggregate state to the component
 */
export const selectIsTrendDeAggregate = createSelector(
  [selectDomain],
  (state) => state.isTrendDeAggregate
);
/**
 *  Getting is moving average visual state to component
 */
export const selectIsMovingAverage = createSelector(
  [selectDomain],
  (state) => state.isMovingAverage
);
/**
 *  Getting trend start date state to component
 */
export const selectTrendStartDate = createSelector([selectDomain], (state) => state.trendStartDate);
/**
 *Getting is search time start date state for search time component for custom date comparison
 */
export const selectSearchTimeStartDate = createSelector(
  [selectDomain],
  (state) => state?.searchTimeStartDate
);
/**
 *Getting is search time end date state for search time component for custom date comparison
 */
export const selectSearchTimeEndDate = createSelector(
  [selectDomain],
  (state) => state?.searchTimeEndDate
);
/**
 * Getting is cumulative state for trend time component
 */
export const selectIsCumulative = createSelector([selectDomain], (state) => state?.isCumulative);
/**
 * Getting trend time weekly view state for trend time component
 */
export const selectTrendTimeWeeklyView = createSelector(
  [selectDomain],
  (state) => state.trendTimeWeeklyView
);
/**
 *  Getting is trend forecast state to the component
 */
export const selectIsForecast = createSelector([selectDomain], (state) => state.isTrendForecast);
/**
 *  Getting moving average filter state to component
 */
export const selectMovingAverage = createSelector([selectDomain], (state) => state.movingAverage);
/**
 *  Getting granularity state to component
 */
export const selectGranularity = createSelector([selectDomain], (state) => state.granularity);
/**
 *  Getting trend segment view filter list state to trend component
 */
export const selectTrendHotelFilterList = createSelector(
  [selectDomain],
  (state) => state.testTrendHotelFilterList
);
/**
 *  Getting trend segment tabular view filter list state to trend component
 */
export const selectTrendHotelTabularFilterList = createSelector(
  [selectDomain],
  (state) => state.testTrendHotelTabularFilterList
);
/**
 *  Getting trend segment view filter list state to trend component
 */
export const selectTrendTimeFilterList = createSelector(
  [selectDomain],
  (state) => state.trendTimeFilterList
);
/**
 *  Getting trend segment tabular view filter list state to trend component
 */
export const selectTrendTimeTabularFilterList = createSelector(
  [selectDomain],
  (state) => state.trendTimeTabularFilterList
);
/**
 *  Getting adjusted start date state to component
 */
export const selectAdjustedStartDate = createSelector(
  [selectDomain],
  (state) => state.adjustedStartDate
);
/**
 *  Getting trend booking date state to component
 */
export const selectAdjustedEndDate = createSelector(
  [selectDomain],
  (state) => state.adjustedEndDate
);
/**
 * Getting segment group 1 to trend  component
 */
export const selectSegmentGroup1 = createSelector([selectDomain], (state) => state.segmentGroup1);
/**
 *  Getting segment group 2 state to trend  component
 */
export const selectSegmentGroup2 = createSelector([selectDomain], (state) => state.segmentGroup2);
/**
 *  Getting trend segment view filter list state to trend component
 */
export const selectTrendSegmentFilterList = createSelector(
  [selectDomain],
  (state) => state.trendSegmentFilterList
);
/**
 *  Getting trend segment tabular view filter list state to trend component
 */
export const selectTrendSegmentTabularFilterList = createSelector(
  [selectDomain],
  (state) => state.trendSegmentTabularFilterList
);
/**
 *  Getting selected scenario object
 */
export const selectSelectedScenario = createSelector(
  [selectDomain],
  (state) => state.selectedScenario
);
/**
 *  Getting all scenarios
 */
export const selectScenarios = createSelector([selectDomain], (state) => state.scenarios);
/**
 *  Getting favorite scenarios
 */
export const selectFavoriteScenarios = createSelector(
  [selectDomain],
  (state) => state.favoriteScenarios
);
/**
 *  Getting favorite scenarios loading
 */
export const selectFavoriteScenarioLoading = createSelector(
  [selectDomain],
  (state) => state.favoriteScenarioLoading
);
